<template>
  <v-container>
    <v-content>
      <h1 class="text-center primary--text pt-4">
        Verbleibende Dokumente
      </h1>
    </v-content>
    <v-row cols="12">
      <v-col cols="12" sm="12">
        <RemainingDocumentsTable></RemainingDocumentsTable>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import RemainingDocumentsTable from '../components/tables/RemainingDocumentsTable'

export default {
  components: {
    RemainingDocumentsTable
  },
  data: () => ({
    content: {}
  }),
  created: function() {},
  methods: {}
}
</script>
